import {
  nhs111TemplateId,
  nhs111ServiceId,
  nhsContraceptionTemplateId,
  nhsContraceptionServiceId,
  nhsSinusitisTemplateId,
  nhsSinusitisServiceId,
  nhsSoreThroatTemplateId,
  nhsSoreThroatServiceId,
  nhsImpetigoTemplateId,
  nhsImpetigoServiceId,
  nhsHypertensionStage1TemplateId,
  nhsHypertensionStage1ServiceId,
  nhsHypertensionABPMFittingTemplateId,
  nhsHypertensionABPMFittingServiceId,
  nhsInsectBitesTemplateId,
  nhsInsectBitesServiceId,
  nhsUtiTemplateId,
  nhsUtiServiceId,
  nhsShinglesServiceId,
  nhsShinglesTemplateId,
  nhsAomTemplateId,
  nhsAomServiceId,
  nhsHypertensionABPMFollowupTemplateId,
  nhsHypertensionABPMFollowupServiceId,
  nhsMinorIllnessTemplateId,
  nhsMinorIllnessServiceId,
  nhsAhtWeightTemplateId,
  nhsAhtWeightServiceId,
  nhsAhtFollowUpTemplateId,
  nhsAhtFollowUpServiceId,
  nhsAhtSixMonthTemplateId,
  nhsAhtSixMonthServiceId,
} from "@/data/constantStrings";

export const NHSServiceIds: Record<string, string> = {
  [nhs111TemplateId]: nhs111ServiceId,
  [nhsContraceptionTemplateId]: nhsContraceptionServiceId,
  [nhsSinusitisTemplateId]: nhsSinusitisServiceId,
  [nhsSoreThroatTemplateId]: nhsSoreThroatServiceId,
  [nhsImpetigoTemplateId]: nhsImpetigoServiceId,
  [nhsHypertensionStage1TemplateId]: nhsHypertensionStage1ServiceId,
  [nhsHypertensionABPMFittingTemplateId]: nhsHypertensionABPMFittingServiceId,
  [nhsInsectBitesTemplateId]: nhsInsectBitesServiceId,
  [nhsUtiTemplateId]: nhsUtiServiceId,
  [nhsShinglesTemplateId]: nhsShinglesServiceId,
  [nhsAomTemplateId]: nhsAomServiceId,
  [nhsHypertensionABPMFollowupTemplateId]: nhsHypertensionABPMFollowupServiceId,
  [nhsMinorIllnessTemplateId]: nhsMinorIllnessServiceId,
  [nhsAhtWeightTemplateId]: nhsAhtWeightServiceId,
  [nhsAhtFollowUpTemplateId]: nhsAhtFollowUpServiceId,
  [nhsAhtSixMonthTemplateId]: nhsAhtSixMonthServiceId,
};

export const NHSServiceNames: Record<string, string> = {
  [nhs111TemplateId]: "NHS 111 Emergency Supply",
  [nhsContraceptionTemplateId]: "NHS Contraception",
  [nhsSinusitisTemplateId]: "NHS Pharmacy First Acute Sinusitis",
  [nhsSoreThroatTemplateId]: "NHS Pharmacy First Acute Sore Throat",
  [nhsImpetigoTemplateId]: "NHS Pharmacy First Impetigo",
  [nhsHypertensionStage1TemplateId]:
    "NHS Hypertension - Stage 1: Initial Consultation",
  [nhsHypertensionABPMFittingTemplateId]:
    "NHS Hypertension - Stage 2: ABPM Fitting",
  [nhsInsectBitesTemplateId]: "NHS Pharmacy First Insect Bites",
  [nhsUtiTemplateId]: "NHS Pharmacy First Uncomplicated UTI",
  [nhsShinglesTemplateId]: "NHS Pharmacy First Shingles",
  [nhsAomTemplateId]: "NHS Pharmacy First Acute Otitis Media",
  [nhsHypertensionABPMFollowupTemplateId]:
    "NHS Hypertension - Stage 3: ABPM Follow Up",
  [nhsMinorIllnessTemplateId]: "NHS Pharmacy First Minor Illness",
  [nhsAhtWeightTemplateId]: "Weight Management (AHT)",
  [nhsAhtFollowUpTemplateId]: "AHT Weight Management — 4-Week Review",
  [nhsAhtSixMonthTemplateId]: "AHT Weight Management — 6-Month Review",
};

export const isNhsService = (templateId?: string | null): boolean => {
  return !!templateId && templateId in NHSServiceIds;
};

export const getNhsServiceId = (
  templateId?: string | null,
): string | undefined => {
  return templateId ? NHSServiceIds[templateId] : undefined;
};

export const getNhsServiceName = (
  templateId?: string | null,
): string | undefined => {
  return templateId ? NHSServiceNames[templateId] : undefined;
};

export const isNhsServiceByServiceId = (serviceId?: string | null): boolean => {
  return !!serviceId && Object.values(NHSServiceIds).includes(serviceId);
};
